/**
 * @prettier
 * @flow
 */
import CssBaseline from '@material-ui/core/CssBaseline';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import { Provider } from 'react-redux';
import { App } from 'src/App';
import { store } from 'src/config/store';

export function AppRoot() {
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <App />
            </ThemeProvider>
        </Provider>
    );
}

const theme = createTheme({
    palette: {
        primary: {
            main: '#2F4050',
        },
        secondary: {
            main: '#08519b',
        },
    },
});
